export default __webpack_public_path__ + "static/media/IconDesc_GolfCart.256.0647b406.png";